import gql from "graphql-tag";

export default gql(`
  mutation submitForm($formid: ID!, $userid: ID!, $data:String!, $datetime:String!) {
      submitForm (formid: $formid, userid: $userid, data:$data, datetime:$datetime ){
        id
      }
  }`);
